import { render, staticRenderFns } from "./scenePsg.vue?vue&type=template&id=4ac07e9b&scoped=true"
import script from "./scenePsg.vue?vue&type=script&lang=js"
export * from "./scenePsg.vue?vue&type=script&lang=js"
import style0 from "./scenePsg.vue?vue&type=style&index=0&id=4ac07e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac07e9b",
  null
  
)

export default component.exports